export const UMB_TREE_ALIAS_CONDITION = 'Umb.Condition.TreeAlias';
